<template>
  <div id="login" v-if="loaded">

    <t-dialog-support/>

    <div class="app-container app-theme-white body-tabs-shadow">

      <div class="h-100">

        <div class="h-100 no-gutters row">

          <div class="h-100 d-flex justify-content-center align-items-center col-md-8 col-xl-6 mx-auto">

            <div class="w-100 mx-auto bg-white borda-login">

              <div class="mx-auto app-login-box col-sm-12 col-md-11">
                <div class="app-logo"></div>
                <h4 class="mb-0 font-titulos">
                  <span class="d-block" v-translate>login-welcome-line-1</span>
                </h4>
                <h6 class="mt-3">Informe seu usuário válido e senha para realizar acesso</h6>

                <div class="divider row"></div>

                <form>

                  <transition name="slide-fade" @after-leave="finishEffect" mode="out-in">

                    <div v-if="!form.success" id="login-not-success">

                      <div class="form-row">

                        <div class="col-md-6">

                          <div class="position-relative form-group">

                            <label for="inputUser" v-translate>user</label>

                            <div class="input-group-icon">

                              <input
                                  v-model.trim="form.user"
                                  :disabled="btnSaveClicked"
                                  style="padding-right: 0; margin-right: 0"
                                  @focusout="focusout()"
                                  :class="{'is-invalid':$v.form.user.$error && formSubmit}"
                                  ref="inputFormUser"
                                  id="inputUser"
                                  class="form-control text-lowercase">

                              <i class="input-icon pe-7s-user"
                                 style="font-size: 18px"></i>

                              <em class="error invalid-feedback"
                                  v-if="$v.form.user.$error && !$v.form.user.required && formSubmit">
                                {{ t('user') }} {{ t('required-o') }}</em>

                              <em class="error invalid-feedback"
                                  v-if="$v.form.user.$error && !$v.form.user.minLength && formSubmit">
                                {{ t('password') }} {{ t('min-length') }}
                                {{ $v.form.user.$params.minLength.min }}
                                {{ t('characters') }}
                              </em>

                              <em class="error invalid-feedback"
                                  v-if="$v.form.user.$error && $v.form.user.minLength && formSubmit">
                                {{ t('user') }} {{ t('invalid') }}</em>

                            </div>

                          </div>
                        </div>

                        <div class="col-md-6">

                          <div class="position-relative form-group">

                            <label for="inputPassword" v-translate>password</label>

                            <div class="input-group-icon">

                              <input v-model.trim="$v.form.password.$model"
                                     :disabled="btnSaveClicked"
                                     :class="{'is-invalid':$v.form.password.$error && formSubmit}"
                                     id="inputPassword"
                                     ref="inputFormPassword"
                                     name="password"
                                     @focusout="focusout()"
                                     autocomplete="current-password"
                                     spellcheck="false"
                                     autocapitalize="off"
                                     :type="visible ? 'text' : 'password'"
                                     class="form-control">

                              <i class="input-icon pe-7s-key"
                                 style="font-size: 18px; left: 12px"></i>

                              <em class="error invalid-feedback"
                                  v-if="$v.form.password.$error && !$v.form.password.required && formSubmit">
                                {{ t('password') }} {{ t('required-a') }}
                              </em>
                              <em class="error invalid-feedback"
                                  v-if="$v.form.password.$error && !$v.form.password.minLength && formSubmit">
                                {{ t('password') }} {{ t('min-length') }}
                                {{ $v.form.password.$params.minLength.min }}
                                {{ t('characters') }}
                              </em>

                              <button
                                  class="btn btn-sm btn-link text-black-50"
                                  type="button"
                                  style="position: absolute; right: 5px; top: 3px"
                                  :aria-label="visible ? 'Ocultar senha' : 'Mostrar senha'"
                                  @mousedown="visible = true"
                                  @mouseup="visible = false"
                                  @mouseleave="visible = false"
                              >
                                <b-icon :icon="visible ? 'eye-slash' : 'eye'"/>

                              </button>

                            </div>

                            <div class="input-group-append">

                            </div>

                          </div>

                        </div>

                      </div>

                      <div class="position-relative form-check">

                        <input name="check" id="exampleCheck"
                               type="checkbox"
                               v-model="form.save_login"
                               :disabled="btnSaveClicked"
                               class="form-check-input">
                        <label for="exampleCheck" class="form-check-label"
                               v-translate>login-keep</label>
                      </div>

                      <div class="divider row"></div>

                      <t-msg v-if="serverErrorCode > 0" danger fade invalid-fast>


                        <span v-if="serverErrorCode === 401">
                          {{ t('login-invalid') }}
                          <b-link :to="'recovery'"
                                  class="alert-link">{{ t('login-recover-password') }}
                          </b-link>
                        </span>

                        <span v-else-if="serverErrorCode === 500">
                          {{ serverErrorMsg }}
                        </span>

                        <span v-else>Erro desconhecido, por favor verifique sua conexão de internet e caso o problema persistir informe nosso Suporte Técnico.</span>

                      </t-msg>


                      <div v-else-if="showLogoutMsg"
                           class="alert alert-warning fade show is-invalid-fast">
                        {{ t('login-logout') }}
                      </div>

                      <div v-else-if="showRecoverySuccessMsg"
                           class="alert alert-info fade show is-invalid-fast">
                        Recuperação de senha realizada com sucesso! Faça o login novamente
                      </div>


                      <div class="d-flex justify-content-center bd-highlight mb-2 mt-4">

                        <div class="d-flex">

                          <t-button-save
                              @save="save"
                              style="padding-right: 90px; padding-left: 90px"
                              :clicked="btnSaveClicked"
                              :text="t('login-button')"
                              :disabled="this.formSubmit && this.$v.$invalid"
                          />

                        </div>

                      </div>

                    </div>

                  </transition>

                  <transition name="slide-fade" @after-enter="effectRedirectHome">

                    <div v-if="hasEffectFinish"
                         class="d-flex justify-content-center pt-5 pb-5"
                         id="login-success">

                      <div class="swal2-icon swal2-success swal2-animate-success-icon"
                           style="display: flex; scale:1.7">
                        <div class="swal2-success-circular-line-left"
                             style="background-color: rgb(255, 255, 255);"></div>
                        <span class="swal2-success-line-tip"></span> <span
                          class="swal2-success-line-long"></span>
                        <div class="swal2-success-ring"></div>
                        <div class="swal2-success-fix"
                             style="background-color: rgb(255, 255, 255);"></div>
                        <div class="swal2-success-circular-line-right"
                             style="background-color: rgb(255, 255, 255);"></div>
                      </div>

                    </div>

                  </transition>

                </form>

                <transition name="slide-fade" mode="out-in">
                  <div v-if="!form.success" class="d-flex justify-content-center">
                    <div class="row">

                      <b-link :to="'recovery'" tabindex="-1" class="btn-lg btn btn-link" v-show="!btnSaveClicked">
                        {{ t('login-recover-password') }}
                      </b-link>

                      <b-link @click="openDialogForm('modal-support')" tabindex="-1" class="btn-lg btn btn-link"
                              v-show="!btnSaveClicked">
                        <span>Suporte Técnico</span>
                      </b-link>

                    </div>
                  </div>
                </transition>


                <div class="divider row"></div>


                <div class="d-flex align-items-center">

                  <a href="https://play.google.com/store/apps/details?id=com.onlaine.app" target="_blank">
                    <img src="https://static.onlaine.com.br/images/playstore.png" class="mr-2 icon-stores"/>
                  </a>

                  <a href="https://apps.apple.com/br/app/onlaine/id6478116349" target="_blank">
                    <img src="https://static.onlaine.com.br/images/applestore.png" class="icon-stores"/>
                  </a>

                  <div class="ml-auto">

                    <span class="text-left pt-3 ml-2" v-translate>language-select</span>
                    <b-dropdown id="dropdown-left" :text="currentlanguage.name" variant="light"
                                class="m-md-2 ml-1">
                      <b-dropdown-item href="#" v-for="language in languages"
                                       :key="language.type"
                                       @click="selectLanguage(language)">{{ language.name }}
                      </b-dropdown-item>
                    </b-dropdown>

                  </div>
                </div>

              </div>

            </div>

          </div>
        </div>
      </div>
    </div>
    <div id="curvas"></div>
  </div>
</template>
<script>
import userService from "@/services/modules/setting/User.service";
import {required, minLength} from 'vuelidate/lib/validators'
import ui from "@/assets/scripts/ui";
import tDialogSupport from "@/components/template/dialog/t-dialog-support";
import functionsMixins from "@/mixins/page/functionsMixins";

export default {
  name: 'Login',
  mixins: [functionsMixins],
  components: {tDialogSupport},
  metaInfo() {
    return {
      title: 'Onlaine ' + this.$translate.text('tech')
    }
  },
  data() {
    return {
      loaded: false,
      visible:false,
      count: 0,
      metaTitle: "",
      showRecoverySuccessMsg: false,
      showLogoutMsg: false,
      serverErrorCode: 0,
      serverErrorMsg: "",
      hasEffectFinish: false,
      currentlanguage: {
        type: "",
        name: ""
      },
      languages: [],
      account: {
        domain: "",
        name: "",
        accountName: "",
        accountPrefix: "",
        login: "",
        authorization: "",
        token: "",
      },
      form: {
        success: false,
        user: '',
        password: '',
        save_login: false,
      },
      formSubmit: false,
      btnSaveClicked: false
    }
  },
  validations: {
    form: {
      user: {
        required,
        minLength: minLength(4)
      },
      password: {
        required,
        minLength: minLength(6)
      },
    }
  },
  created() {
    ui.defaultTemplate()
  },
  computed: {

    /*hasAccountDomain() {
      return this.account.domain !== ''
    }*/
  },
  async mounted() {

    this.languages = this.$store.getters.getLanguages

    if (this.$route.query.from) {

      await userService.from(this, this.$route.query.a, this.$route.query.t).then(() => {
        this.form.success = true
      }).catch(error => {
        console.log(error)
      })

    }


    if (this.$route.query.recovery) {
      this.showRecoverySuccessMsg = true;
    }

    if (this.$route.query.logout) {
      this.showLogoutMsg = true;
    }


    //this.currentlanguage = JSON.parse(localStorage.getItem('language'))
    this.currentlanguage = JSON.parse(localStorage.getItem('language'))

    //Obtem do navegador
    if (localStorage.getItem('account')) {
      this.account = JSON.parse(localStorage.getItem('account'))
    }

    //Armazena no store local do Vue
    this.$store.commit("setAccount", this.account)

    //Tenta redirecionar, pois possui uma conta válida
    if (this.account && this.account.token && this.account.token !== '') {

      this.redirectHome();

    } else {
      //Verifica se há login salvo

      if (localStorage.getItem('username')) {
        this.form.user = JSON.parse(localStorage.getItem('username'))
        this.form.save_login = true
      }

      //Libera a tela, pois será necessário efetuar o login
      this.loaded = true

      //Tempo para desenhar na tela e focus no campo correto
      setTimeout(() => {

        if (this.form.save_login) {

          if (this.$refs.inputFormPassword)
            this.$refs.inputFormPassword.focus()

        } else {

          if (this.$refs.inputFormUser)
            this.$refs.inputFormUser.focus()

        }

      }, 200)
    }


  },
  methods: {

    //Necessário, pois foi realizado tratamento no valor antes de validação
    setUser(value) {
      this.form.user = value
      this.$v.form.user.$touch()
    },
    focusout() {

      if (this.form.user !== null && this.form.user !== '') {
        this.form.user = this.form.user.replaceAll('\t', '')
      }

      if (this.form.password !== null && this.form.password !== '') {
        this.form.password = this.form.password.replaceAll('\t', '')
      }

    },
    finishEffect() {
      this.hasEffectFinish = true
    },
    effectRedirectHome() {
      setTimeout(() => {

        //Deverá fazer um reload para carregar as rotas de acordo com domínio do cliente
        ui.reload()

      }, 1000)
    },
    redirectHome() {


      const redirectedFrom = localStorage.getItem('redirectedFrom')

      if (redirectedFrom !== undefined && redirectedFrom !== null && redirectedFrom !== '' && redirectedFrom !== 'undefined') {

        //Remove para parar de redirecionar sempre
        localStorage.removeItem('redirectedFrom')
        ui.goLink(redirectedFrom)

      } else {

        //Página inicial padrão
        this.$router.push({name: 'dashboard'})

      }

    },
    selectLanguage(language) {
      localStorage.setItem('language', JSON.stringify(language))
      this.$translate.setLang(language.type)
      this.currentlanguage = language
    },
    async save() {

      this.formSubmit = true
      this.$v.$touch()
      this.count++

      if (!this.$v.$invalid) {

        this.btnSaveClicked = true
        this.serverErrorCode = 0
        this.serverErrorMsg = ""

        await userService.login(this, this.form.user, this.form.password, this.form.save_login).then(() => {
          this.form.success = true
        }).catch(error => {

          this.serverErrorCode = 401 //Padrão de erro

          this.formSubmit = false
          this.form.password = ""
          this.btnSaveClicked = false

          if (error.response) {

            const status = error.response.status

            if (error.response.status === 500) {
              this.serverErrorCode = 500

              if (error.response.data.message) {
                this.serverErrorMsg = error.response.data.message
              } else if (error.response.data.general) {
                this.serverErrorMsg = error.response.data.general[0]
              }

            } else {
              this.serverErrorCode = status
            }

          }

        })

      }

    }
  }
}
</script>

<style scoped>

.app-container {
  background: url("https://static.onlaine.com.br/images/curvas.png") no-repeat right 600px;
}

.borda-login {
  border: solid 1px #CCC;
  border-radius: 5px;
  padding-top: 5%;
  padding-bottom: 5%;
  max-width: 800px;
  box-shadow: 0px 0px 15px 15px #FFF;
}

.slide-fade-enter-active {
  transition: all .3s ease;
}

.slide-fade-leave-active {
  transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}

.slide-fade-enter, .slide-fade-leave-to {
  transform: translateX(10px);
  opacity: 0;
}
</style>
